import Vue from "vue";
import axios from "axios";
import moment from "moment";
import dmTools from "@/employee/dm/dmTools";

const stageDef = {
  Reconnections: { name: "Reconnections", type: 5 },
  Disconnections: { name: "Disconnections", type: 2 },
};

export default {
  name: "Dm",
  props: {
    dataObj: {
      type: Object,
      required: true,
    },
    offline: {
      type: Boolean,
      default: false,
    },
    externalSavePic: {
      type: Function,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    isRemoveInstallMeter: {
      type: Boolean,
      default: false,
    },
    existingMeterItems: {
      type: Array,
      default: () => {
        [];
      },
    },
  },
  components: {
    CameraComp:
      require("@/components/uploadPictureToActivityAttachment/uploadPictureToActivityAttachment.vue")
        .default,
    SelectSerialNo:
      require("@/employee/dm/newDebtManagement/dmEditRecord/dmEditRecordSelectMeterSerialNo.vue")
        .default,
  },
  mixins: [dmTools],
  data: function () {
    return {
      dmSettings: null,
      showInfoDialog: true,
      suggestedMeter: {},
      selectMeterDialog: false,
      appData: {
        account: "",
        caseId: 0,
        connectionId: 0,
        finalReading: "0",
        previousReading: 0,
        finalReadingDate: new Date(),
        finalReadingDateAux: new Date(),
        finalReadingClockOver: false,
        removeMeter: false,
        installMeter: false,
        isUnderInvestigation: false,
        onlyComments: false,
        removeFromInvestigation: false,
        bInvalid: false,
        comment: "",
        readonly: false,
        bIsDateSet: false,
        isAllowDisconReconWithoutReading: false,
      },
      showDate: { finalReadingDate: false, finalReadingDateAux: false },
      finalReadingDate: {},
      finalReadingDateAux: {},
      bRemoveMeter: false,
      bInstallMeter: false,
      meters: [],
      meter: {},
      serialNoSearchLen: -1,
      disabledDates: (date) => {
        let day = moment(date);
        let today = moment();
        return day > today;
      },
      enableSerialEdit: false,
      utilitySettings: {},
    };
  },
  computed: {
    currSymbol: function () {
      let temp = this.$store.getters.getSettings;
      if (temp && temp.currencySymbol) return temp.currencySymbol;
      else return;
    },
    finalReadingDateDisplay: {
      get: function () {
        return this.$options.filters.formatDateDDMMYYY(
          this.appData.finalReadingDate
        );
      },
      set: function () {},
    },
    showEditSerialButton: function () {
      return (
        this.isRemoveInstallMeter &&
        this.appData.stage == 5 &&
        this.enableSerialEdit
      );
    },
    disableSerialButton: function () {
      return !this.isSerialReadOnly && (this.appData.isSaved || this.readOnly);
    },
    commentDisabled: function () {
      if (this.appData.onlyComments) return false;

      return this.appData.readonly || this.readOnly || this.appData.isSaved;
    },
    allowShowInfoDialog: function () {
      if (this.dmSettings) {
        let val = Object.values(this.dmSettings);
        if (!val || val.length == 0) return false;

        let res = val[0];

        if (val.length > 1) {
          for (let i = 1; i < val.length; i++) res = res || val[i];
        }

        return res;
      }

      return false;
    },
  },
  watch: {
    "appData.finalReadingDate": function (value) {
      let newDte = moment().add(1, "days");
      if (
        !this.appData.isUnderInvestigation &&
        !this.appData.onlyComments &&
        moment(value).isAfter(newDte)
      ) {
        this.$alertMsg(this.$t("captureMR.currDateError"));
        this.appData.finalReadingDate = new Date();
        return;
      }
    },
    "appData.sequence": function (value) {
      this.fixSuggestedSerialNo();
    },
    meter: function (value) {
      this.appData.meterId = value.meterId;
      if (this.$refs.select) this.$refs.select.open = false;
    },
    bRemoveMeter: function (value) {
      this.appData.removeMeter = value;
    },
    bInstallMeter: function (value) {
      this.appData.installMeter = value;
      if (value === true) this.getExistingMeterItems();
    },
  },
  created() {
    this.init();
    this.$root.$on("dm_updated", this.init);
  },
  methods: {
    onElementSearch(val) {
      if (val.length < this.serialNoSearchLen) return;

      this.getExistingMeterItems(val);
    },
    init() {
      Vue.nextTick(async () => {
        this.fixSuggestedSerialNo();

        this.appData = this.dataObj;
        this.appData.bIsDateSet = false;

        this.dmSettings = this.$store.getters.getDmSettings;
        await this.$store
          .dispatch("getUtilitySettings")
          .then(async (response) => {
            if (response) this.utilitySettings = response;
          });
      });
    },
    fixSuggestedSerialNo() {
      if (!this.dataObj.meterSerialNo) {
        this.enableSerialEdit = true;
      }

      this.suggestedMeter = {
        suggestedMeterSerialNo: this.dataObj.suggestedMeterSerialNo,
        suggestedMeterId: this.dataObj.suggestedMeterId,
      };
    },
    getExistingMeterItems(val) {
      var parameter = {
        ExistingSerialNo: false,
        SerialNo: val ? val : "",
      };
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/DmConnection/GetExistingMeterItems", parameter)
        .then((response) => {
          if (response.data.data.status == 0) {
            this.meters = response.data.items;
          } else {
            this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch((e) => {
          loader.hide();
          this.$router.push("/login");
          return false;
        });
    },
    putOrRemoveFromInvestigation() {
      if (this.appData.isUnderInvestigation) {
        this.appData.removeFromInvestigation = true;
        this.appData.isUnderInvestigation = false;
      } else {
        this.appData.removeFromInvestigation = false;
        this.appData.isUnderInvestigation = true;
      }
    },
    openSelectMeterDialog() {
      this.selectMeterDialog = true;
    },
    completeInitialReading() {
      this.appData.finalReading = this.dataObj.suggestedMeterLastReading;
    },
    meterSerialSelected(item) {
      if (!item) return;

      this.appData["meterIdForSave"] = item.meterId;
      this.appData.meterSerialNo = item.ref;

      if (item.selected) this.closeSelectMeterDialog(true);
    },
    closeSelectMeterDialog(isSelected) {
      if (!isSelected) {
        this.appData["meterIdForSave"] = "";
        this.appData.meterSerialNo = "";
      }

      this.selectMeterDialog = false;
    },
  },
};
